const megaNavDesk = () => {
	$(() => {
		let navItem = $('.navCont__bottomLi');
		let bottomRight = $('.navCont__bottomRight');
		let mobileNavItem = $('.mobile-nav__level1');
		let backToMenu = $('.backToMenu');
		let exit = $('.mega__exit');
		let link = $('.navCont__bottomLiA');
		let megaInside = $('.mega__inside');

		function enterDesk(e) {
			let targetId = e.target.id;
			if (targetId === undefined || targetId === null || targetId === '') {
				targetId = e.target.dataset.id;
			}
			if (targetId === undefined || targetId === null || targetId === '') {
				return;
			}
			$('.mega').css('display', 'none');
			$('.mega__wrap').css('display', 'none');
			$('.mega').attr('aria-expanded', false);
			$('.mega[data-id="' + targetId + '"]').css('display', 'block');
			$('.mega__wrap[data-id="' + targetId + '"]').css('display', 'block');
			$('.mega__inside[data-id="' + targetId + '"]').css('opacity', '1');
			$('.mega[data-id="' + targetId + '"]').attr('aria-expanded', true);
		}

		function exitDesk() {
			$('.mega').css('display', 'none');
			$('.mega__inside').css('opacity', '0');
			$('.mega').attr('aria-expanded', false);
		}

		function openMobile(e) {
			let datasetId = e.target.dataset.id;
			$('.mega').toggleClass('mega--open');
			$('.mobile-nav__levelMenu[data-id=' + datasetId + ']').toggleClass(
				'mobile-nav__levelMenu--open'
			);
			$('.mega[data-id="' + datasetId + '"]').css('display', 'block');
			$('.mega__wrap[data-id="' + datasetId + '"]').css('display', 'block');
			$('.mega__inside[data-id="' + datasetId + '"]').css('opacity', '1');
		}
		function backMenu() {
			$('.mega').toggleClass('mega--open');
			$('.mobile-nav__levelMenu').removeClass('mobile-nav__levelMenu--open');
		}
		megaInside.on('keydown', function (e) {
			if (e.key === 'Escape') {
				exitDesk();
			}
		});
		navItem.on('mouseenter focus', enterDesk);
		link.on('focus', enterDesk);
		bottomRight.on('mouseleave focus', exitDesk);
		exit.on('mouseenter focus', exitDesk);
		mobileNavItem.on('click', openMobile);
		backToMenu.on('click', backMenu);
	});
};
export default megaNavDesk;
